import { useCallback, useEffect, useState } from 'react'
import { rpc } from '../../api/rpc'

/** A repository registered for work in one workspace (docs/connectors.md §10). */
export interface RepoRef {
  id: string
  workspaceId: string
  connectorId: string
  /** The user who registered it; the list only ever contains the caller's own. */
  ownerUserId: string
  owner: string
  name: string
  defaultBranch: string
  readOnly: boolean
  createdAt: number
}

/** Repositories registered in one workspace; reloaded when the workspace changes. */
export function useRepos(workspaceId: string | undefined) {
  const [items, setItems] = useState<RepoRef[]>([])
  const reload = useCallback(async () => {
    if (!workspaceId) { setItems([]); return }
    setItems((await rpc.call<{ items: RepoRef[] }>('repos.list', { workspaceId })).items)
  }, [workspaceId])
  useEffect(() => { void reload().catch(() => undefined) }, [reload])
  return { items, reload }
}
